/**
 * @ngdoc services
 * @memberof mercury.services
 * @name authService
 * @description Service for managing user authentication
 */
angular.module('mercury.services.auth', [])
.factory('authService', ["$http", "$injector", "$q", "localStorageService", "settings", function($http, $injector, $q, localStorageService, settings) {
  var xFormTransformer = function(data) {
    var str = [];
    for (var p in data) {
      str.push(p + '=' + data[p]);
    }
    return str.join('&');
  };

  var refreshTokenDeferred = null;

  /**
   * Stored the input tokens in local storage to authenticate all requests with.
   *
   * @memberof authService
   * @param {String} accessToken Bearer token for use in Authorization header
   * @param {String} refreshToken Refresh token to obtain new accessTokens without re-auth
   * @param {Boolean} forceSaveRefreshToken default behaviour is to only save the refreshtoken if there's already one there. Set this to true to always save
   */
  function setToken(accessToken, refreshToken, forceSaveRefreshToken) {
    data = {};
    data.accessToken = accessToken;

    // When the user first logs in, if they check the remember be checkbox then we'll
    // store the refresh token from that login. If not then it will be null
    // So here we check that value and only store the refresh token if we have a previous one
    var oldData = localStorageService.get('authorizationData');
    if (oldData && oldData.refreshToken || forceSaveRefreshToken) {
      data.refreshToken = refreshToken;
    }

    localStorageService.set('authorizationData', data);

    // Set the default Authorization header
    $http.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
  }

  /**
   * Check if the user is authenticated
   *
   * @memberof authService
   */
  function getToken() {
    var authData = localStorageService.get('authorizationData');
    return authData && authData.accessToken ? authData.accessToken : null;
  }

  /**
   * Redirect the user to the Front page
   *
   * @memberof authService
   */
  function clearToken() {
    localStorageService.remove('authorizationData');
  }

  /**
   * Use the use the username and password to re-login, and refresh credentials
   *
   * @memberof authService
   */
  function reLogin(username, password) {
    if (refreshTokenDeferred !== null) {
      return refreshTokenDeferred.promise;
    }

    refreshTokenDeferred = $q.defer();
    var data = {};

    data.username = encodeURIComponent(username);
    data.password = encodeURIComponent(password);
    /* jshint ignore:start */
    //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
    data.grant_type = 'password';
    data.client_id = 'mercury';
    //jscs:enable requireCamelCaseOrUpperCaseIdentifiers
    /* jshint ignore:end */

    localStorageService.remove('authorizationData');

    $http.post(
      settings.mercHost + '/Token',
      data,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: null
        },
        transformRequest: xFormTransformer
      }
    ).success(function(response) {
      /* jshint ignore:start */
      //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
      setToken(response.access_token, response.refresh_token);
      //jscs:enable requireCamelCaseOrUpperCaseIdentifiers
      /* jshint ignore:end */

      refreshTokenDeferred.resolve(response);
      refreshTokenDeferred = null;
    }).error(function(err) {
      refreshTokenDeferred.reject(err);
      refreshTokenDeferred = null;
    });
    return refreshTokenDeferred.promise;
  }

  /**
   * Use the refresh token to re-new the access token
   *
   * @memberof authService
   */
  function refreshCredentials() {
    if (refreshTokenDeferred !== null) {
      return refreshTokenDeferred.promise;
    }

    refreshTokenDeferred = $q.defer();
    var authData = localStorageService.get('authorizationData');

    if (authData && authData.refreshToken) {
      var data = {};

      /* jshint ignore:start */
      //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
      data.grant_type = 'refresh_token';
      data.refresh_token = authData.refreshToken;
      data.client_id = 'mercury';
      //jscs:enable requireCamelCaseOrUpperCaseIdentifiers
      /* jshint ignore:end */

      localStorageService.remove('authorizationData');

      $http.post(
        settings.mercHost + '/Token',
        data,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: null
          },
          transformRequest: xFormTransformer
        }
      ).success(function(response) {
        /* jshint ignore:start */
        //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        setToken(response.access_token, response.refresh_token, true);
        //jscs:enable requireCamelCaseOrUpperCaseIdentifiers
        /* jshint ignore:end */

        refreshTokenDeferred.resolve(response);
        refreshTokenDeferred = null;
      }).error(function(err) {
        refreshTokenDeferred.reject(err);
        refreshTokenDeferred = null;
      });
      return refreshTokenDeferred.promise;
    } else {
      refreshTokenDeferred.reject();
      refreshTokenDeferred = null;
      return $q.reject();
    }
  }

  return {
    setToken: setToken,
    getToken: getToken,
    clearToken: clearToken,
    refreshCredentials: refreshCredentials,
    reLogin: reLogin
  };
}]);
